import { useCallback } from 'react'

import { useDeleteSubjectReconciliationSuggestion } from '@features/paymentReconciliationModal/hooks/useDeleteSubjectReconciliationSuggestion'
import { DeleteSubjectReconciliationMatchPayload } from '@features/paymentReconciliationModal/query-api'
import { UiSourceValue } from '@features/reconciliation/enums'
import { ReconciliationSuggestion } from '@modules-deprecated/bankReconciliation/types'

import { queryClient } from '../../../config/queryClient'
import { QueryKeys } from '../../../enums/queryKeys'

interface UseRejectSuggestionProps {
  onSuccess?: () => void
  onError?: (errorMessage?: string) => void
  uiSource?: UiSourceValue
}

interface RejectSuggestionParams {
  matchSuggestion?: ReconciliationSuggestion
}

export const useRejectSuggestion = (props: UseRejectSuggestionProps) => {
  const { onSuccess, onError, uiSource } = props || {}

  const { deleteSuggestion, isProcessing: isRejecting } = useDeleteSubjectReconciliationSuggestion({
    onSuccess: () => {
      queryClient.invalidateQueries(QueryKeys.BankLineSuggestions)
      onSuccess?.()
    },
    onError: (error) => {
      onError?.(error?.message)
    },
  })

  const rejectSuggestion = useCallback(
    ({ matchSuggestion }: RejectSuggestionParams) => {
      if (matchSuggestion) {
        const payload: DeleteSubjectReconciliationMatchPayload = {
          organizationId: matchSuggestion.reconcilables[0].organization_id,
          suggestion: matchSuggestion,
          uiSource,
        }

        deleteSuggestion(payload)
      }
    },
    [deleteSuggestion, uiSource],
  )

  return {
    isRejecting,
    rejectSuggestion,
  }
}
